import chroma from "chroma-js";

function resolveCssVariable(color: string): string {
  const variableName = color.match(/^var\((--[^,\s)]+)/)?.[1];

  if (variableName == null || typeof window === "undefined") {
    return color;
  }

  return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim() || color;
}

export function getContrastColor(color?: string | chroma.Color | null): string | undefined {
  if (color == null) {
    return undefined;
  }

  const resolvedColor = typeof color === "string" ? resolveCssVariable(color) : color;

  if (typeof resolvedColor === "string" && !chroma.valid(resolvedColor)) {
    return undefined;
  }

  // https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html
  // The ISO-9241-3 declares a contrast ratio of 4.5:1 as the minimum level for text to be readable.
  // Basti finds that red need a white font color therefor the contrast ratio is 6.6:1 on black in our system otherwise its white
  return chroma.contrast(resolvedColor, "black") > 6.6 ? "black" : "white";
}
